import { useNavigate } from "react-router-dom";
import { getLocal, NFeDto, STORAGENFE_KEY, updateLocal } from "../NFe.Dto";
import { useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import yup from "src/validators/yup.Module";
import {
  Badge,
  Button,
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
  Table,
} from "react-bootstrap";
import {
  MapearErrosServidor,
  MapearErrosServidorCampo,
  SoNumeros,
} from "src/hook/Functions";
import { ButtonSpinner, FloatInput, showToast } from "src/componentes";
import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import {
  PessoaDto,
  PessoaFiltrarDto,
} from "src/pages/Privada/Entidade/Pessoa/Pessoa.Dto";
import { PessoaFiltrar, PessoaIncluir } from "src/services/Entidade.Service";
import {
  CategoriaBuscarTodos,
  ProdutoFiltrar,
  ProdutoIncluir,
} from "src/services/Estoque.Service";
import { ProdutoCadastroDto } from "src/pages/Privada/Estoque/Produto/Cadastro/ProdutoCadastro.Dto";
import { ProdutoNFCeDto } from "../../NFCe/NFCe.Dto";
import { CategoriasCadastroDto } from "src/pages/Privada/Estoque/Categorias/Cadastro/CategoriasCadastro.Dto";

const NFeCadastroReferenciaView = () => {
  const nf = getLocal<NFeDto>(STORAGENFE_KEY);
  const referencia = nf?.referencia;
  const navigate = useNavigate();

  type FormType = yup.InferType<typeof schema>;
  const schema = yup.object({
    dadosReferencia: yup.array().of(
      yup.object().shape({
        chaveAcesso: yup
          .string()
          .length(44, "A chave de acesso deve ter 44 caracteres")
          .required("Chave de acesso é obrigatória"),
      })
    ),
  });

  const handleVoltar = () => {
    navigate("../finalidade");
  };

  const form = useForm<FormType>({
    resolver: yupResolver(schema),
    defaultValues: {
      dadosReferencia: referencia ?? [],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "dadosReferencia",
  });

  const [showModal, setShowModal] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [chNFeTemp, setChNFeTemp] = useState("");
  const [itensTemp, setItensTemp] = useState<any[]>([]);
  const [categorias, setCategorias] = useState<CategoriasCadastroDto[]>([]);

  useEffect(() => {
    const carregarCategorias = async () => {
      try {
        const res = await CategoriaBuscarTodos();
        if (res.data.success) {
          setCategorias(res.data.data);
        }
      } catch (err) {
        console.error("Erro ao carregar categorias");
      }
    };
    carregarCategorias();
  }, []);

  const destForm = useForm<PessoaDto>({
    defaultValues: {},
  });

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (event) => {
      setShowModal(true);
      setLoadingSearch(true);
      try {
        const text = event.target?.result as string;
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(text, "text/xml");

        let chNFe = xmlDoc.getElementsByTagName("chNFe")[0]?.textContent;

        if (!chNFe) {
          const infNFe = xmlDoc.getElementsByTagName("infNFe")[0];
          const idStr = infNFe?.getAttribute("Id");
          if (idStr && idStr.startsWith("NFe")) {
            chNFe = idStr.substring(3);
          }
        }

        if (chNFe && chNFe.length === 44) {
          const dest = xmlDoc.getElementsByTagName("dest")[0];
          const enderDest = dest?.getElementsByTagName("enderDest")[0];

          const cnpj = dest?.getElementsByTagName("CNPJ")[0]?.textContent || "";
          const cpf = dest?.getElementsByTagName("CPF")[0]?.textContent || "";
          const documento = cnpj || cpf;

          const filtro: PessoaFiltrarDto = {
            documento: SoNumeros(documento),
            perfilPessoa: 0,
          };

          const res = await PessoaFiltrar(filtro);

          if (res.data.success) {
            if (res.data.data.length > 0) {
              destForm.reset(res.data.data[0]);
            } else {
              const nome =
                dest?.getElementsByTagName("xNome")[0]?.textContent || "";
              const novaPessoa: PessoaDto = {
                id: 0,
                nome: nome,
                documento: documento,
                nomeMunicipio:
                  enderDest?.getElementsByTagName("xMun")[0]?.textContent || "",
                uf: enderDest?.getElementsByTagName("UF")[0]?.textContent || "",
                nomeFantasia:
                  dest?.getElementsByTagName("xFant")[0]?.textContent ||
                  nome ||
                  "",
                endereco:
                  enderDest?.getElementsByTagName("xLgr")[0]?.textContent || "",
                enderecoNumero:
                  enderDest?.getElementsByTagName("nro")[0]?.textContent || "",
                enderecoComplemento:
                  enderDest?.getElementsByTagName("xCpl")[0]?.textContent || "",
                bairro:
                  enderDest?.getElementsByTagName("xBairro")[0]?.textContent ||
                  "",
                codigoMunicipio:
                  enderDest?.getElementsByTagName("cMun")[0]?.textContent || "",
                cep:
                  enderDest?.getElementsByTagName("CEP")[0]?.textContent || "",
                codigoPais:
                  enderDest?.getElementsByTagName("cPais")[0]?.textContent ||
                  "1058",
                nomePais:
                  enderDest?.getElementsByTagName("xPais")[0]?.textContent ||
                  "BRASIL",
                indicadorInscricaoEstadual: 9,
                inscricaoEstadual:
                  dest?.getElementsByTagName("IE")[0]?.textContent || "",
                apelido: nome.split(" ")[0].trim(),
                perfilPessoa: 1, // Cliente/Destinatário
              };
              destForm.reset(novaPessoa);
            }
          } else {
            MapearErrosServidor(res.data.notifications, showToast);
          }

          // Processar Itens
          const dets = xmlDoc.getElementsByTagName("det");
          const itensNFe: any[] = [];

          for (let i = 0; i < dets.length; i++) {
            const det = dets[i];
            const prod = det.getElementsByTagName("prod")[0];

            const cProd =
              prod?.getElementsByTagName("cProd")[0]?.textContent || "";
            const xProd =
              prod?.getElementsByTagName("xProd")[0]?.textContent || "";
            const ncm = prod?.getElementsByTagName("NCM")[0]?.textContent || "";
            const uCom =
              prod?.getElementsByTagName("uCom")[0]?.textContent || "";
            const qCom = parseFloat(
              prod?.getElementsByTagName("qCom")[0]?.textContent || "0"
            );
            const vUnCom = parseFloat(
              prod?.getElementsByTagName("vUnCom")[0]?.textContent || "0"
            );
            const vProd = parseFloat(
              prod?.getElementsByTagName("vProd")[0]?.textContent || "0"
            );
            const cEAN =
              prod?.getElementsByTagName("cEAN")[0]?.textContent || "";
            const cfop =
              prod?.getElementsByTagName("CFOP")[0]?.textContent || "";

            // Verificar se o produto existe
            const resProd = await ProdutoFiltrar({ codigoProduto: cProd });
            let produtoExistente = null;
            if (resProd.data.success && resProd.data.data.length > 0) {
              produtoExistente = resProd.data.data[0];
            }

            itensNFe.push({
              id: produtoExistente?.id || 0,
              codigoProduto: cProd,
              codigoBarras: cEAN === "SEM GTIN" ? "" : cEAN,
              nome: xProd,
              descricao: xProd,
              unidadeComercial: uCom,
              quantidadeComercial: qCom,
              valorUnitarioComercial: vUnCom,
              valorTotal: vProd,
              codigoNCM: ncm,
              cfop: cfop,
              categoriaId: produtoExistente?.categoriaId || 1,
              existente: !!produtoExistente,
            });
          }
          setItensTemp(itensNFe);
          setChNFeTemp(chNFe);
        } else {
          setShowModal(false);
          showToast({
            message:
              "Não foi possível encontrar a chave de acesso no arquivo XML.",
            variant: "Warning",
            title: "Atenção",
          });
        }
      } catch (err) {
        setShowModal(false);
        showToast({
          message: "Erro ao processar arquivo XML.",
          variant: "Danger",
          title: "Erro",
        });
      } finally {
        setLoadingSearch(false);
      }
    };
    reader.readAsText(file);
    e.target.value = "";
  };

  const handleConfirmXml = async () => {
    setLoadingConfirm(true);
    try {
      let pessoa = destForm.getValues();
      pessoa.documento = SoNumeros(pessoa.documento);
      pessoa.cep = SoNumeros(pessoa.cep);

      if (pessoa.id === 0) {
        try {
          const res = await PessoaIncluir(pessoa);
          if (!res.data.success) {
            MapearErrosServidorCampo(res.data.notifications, destForm.setError);
            MapearErrosServidor(res.data.notifications, showToast);
            showToast({
              message: "Ocorreu erro ao incluir cadastro",
              title: "Erro",
              variant: "Danger",
            });
            return;
          }
          pessoa = res.data.data;
        } catch (error) {
          showToast({
            message: "Erro ao cadastrar novo destinatário.",
            variant: "Danger",
          });
          return;
        }
      }

      // Cadastrar produtos novos e montar itens final
      const nfLocal = getLocal<NFeDto>(STORAGENFE_KEY);
      const currentItens = nfLocal?.itens ?? [];
      const offset = currentItens.length;

      const itensFinal: ProdutoNFCeDto[] = [];
      for (const item of itensTemp) {
        let idProduto = item.id;
        if (item.id === 0) {
          try {
            const prodParaIncluir: ProdutoCadastroDto = {
              id: 0,
              codigoProduto: item.codigoProduto,
              codigoBarras: item.codigoBarras,
              nome: item.nome,
              descricao: item.descricao,
              valorUnitarioComercial: item.valorUnitarioComercial.toString(),
              categoriaId: item.categoriaId,
              categoriaNome: "",
              codigoNCM: item.codigoNCM,
              unidadeComercial: item.unidadeComercial,
            };
            const resI = await ProdutoIncluir(prodParaIncluir);
            if (resI.data.success) {
              idProduto = resI.data.data.id;
            }
          } catch (err) {
            console.error("Erro ao cadastrar produto", item.codigoProduto);
          }
        }

        itensFinal.push({
          index: offset + itensFinal.length + 1,
          id: idProduto,
          categoriaId: item.categoriaId,
          codigoProduto: item.codigoProduto,
          codigoBarras: item.codigoBarras,
          nome: item.nome,
          descricao: item.descricao,
          codigoNCM: item.codigoNCM,
          cfop: item.cfop,
          sequencia: offset + itensFinal.length + 1,
          unidadeComercial: item.unidadeComercial,
          quantidadeComercial: item.quantidadeComercial,
          valorUnitarioComercial: item.valorUnitarioComercial,
          valorTotal: item.valorTotal,
          codigoBarrasTributavel: item.codigoBarras,
          unidadeTributavel: item.unidadeComercial,
          quantidadeTributavel: item.quantidadeComercial,
          valorUnitarioTributavel: item.valorUnitarioComercial,
          valorFrete: 0,
          valorSeguro: 0,
          valorDesconto: 0,
          outrasOutro: 0,
          indicaTotal: 1,
          categoriaNome: "",
        } as ProdutoNFCeDto);
      }

      if (chNFeTemp) {
        append({ chaveAcesso: chNFeTemp });
        showToast({
          message: "XML importado com sucesso!",
          variant: "Success",
        });
      }

      updateLocal<NFeDto>(STORAGENFE_KEY, {
        destinatario: pessoa,
        itens: [...currentItens, ...itensFinal],
      });

      setShowModal(false);
      setChNFeTemp("");
      setItensTemp([]);
      destForm.reset({});
    } finally {
      setLoadingConfirm(false);
    }
  };

  const onSubmit = (data: FormType) => {
    if (
      data.dadosReferencia == undefined ||
      data.dadosReferencia.length === 0
    ) {
      showToast({
        message: "Adicione ao menos um documento de referência.",
        variant: "Danger",
        title: "Atenção",
      });
      return;
    }

    const referencias = data.dadosReferencia ?? [];

    updateLocal<NFeDto>(STORAGENFE_KEY, {
      referencia: referencias,
    });

    navigate("../tributacao");
  };

  return (
    <>
      <Form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="mt-3" style={{ marginBottom: "100px" }}>
          {fields.map((field, index) => {
            return (
              <Row key={field.id} className="mb-3">
                <Col xs={12} className="mb-2 d-flex justify-content-between">
                  <strong>Referência {index + 1}</strong>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => remove(index)}
                  >
                    Remover
                  </Button>
                </Col>
                <Col xs={12}>
                  <FloatInput
                    label="Chave de Acesso"
                    maxLength={44}
                    registerField={form.register(
                      `dadosReferencia.${index}.chaveAcesso`
                    )}
                    errorsMessage={
                      form.formState.errors.dadosReferencia?.[index]
                        ?.chaveAcesso
                    }
                  />
                </Col>
              </Row>
            );
          })}
          <Dropdown className="d-grid mt-3">
            <Dropdown.Toggle variant="outline-primary" id="dropdown-add-ref">
              Adicionar Referência
            </Dropdown.Toggle>

            <Dropdown.Menu className="w-100">
              <Dropdown.Item onClick={() => fileInputRef.current?.click()}>
                Importar XML NFe
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item
                onClick={() =>
                  append({
                    chaveAcesso: "",
                  })
                }
              >
                Digitar Manualmente
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <input
            type="file"
            accept=".xml"
            hidden
            ref={fileInputRef}
            onChange={handleFileChange}
          />
        </div>

        <div className="fixed-bottom">
          <Container className="py-3">
            <Row>
              <Col xs={6} className="d-grid">
                <Button variant="outline-secondary" onClick={handleVoltar}>
                  Voltar
                </Button>
              </Col>
              <Col xs={6} className="d-grid">
                <Button variant="outline-primary" type="submit">
                  Próximo
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      </Form>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Importação de XML</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingSearch ? (
            <Placeholder as={FloatingLabel} animation="glow">
              <Placeholder xs={12} className="mb-3" />
              <Placeholder xs={12} className="mb-3" />
              <Placeholder xs={12} className="mb-3" />
            </Placeholder>
          ) : (
            <>
              <h6>Dados do Destinatário</h6>
              <hr />
              {destForm.watch("id") === 0 && (
                <div className="alert alert-info text-center py-1 mb-2">
                  <small className="fw-bold">
                    Destinatário será importado para a base de dados
                  </small>
                </div>
              )}
              <Row>
                <Col xs={12} className="mb-3">
                  <FloatInput
                    label="Nome"
                    registerField={destForm.register("nome")}
                    readOnly={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={4} className="mb-3">
                  <FloatInput
                    label="Documento"
                    registerField={destForm.register("documento")}
                    readOnly={true}
                  />
                </Col>
                <Col xs={10} md={6} className="mb-3">
                  <FloatInput
                    label="Município"
                    registerField={destForm.register("nomeMunicipio")}
                    readOnly={true}
                  />
                </Col>
                <Col xs={2} md={2} className="mb-3">
                  <FloatInput
                    label="UF"
                    registerField={destForm.register("uf")}
                    readOnly={true}
                  />
                </Col>
              </Row>

              <h6 className="mt-4">Itens da Nota</h6>
              <hr />
              <div
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  fontSize: "0.85rem",
                }}
              >
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>Código</th>
                      <th>Descrição</th>
                      <th style={{ width: "200px" }}>Categoria</th>
                      <th className="text-center">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {itensTemp.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item.codigoProduto}</td>
                        <td>{item.nome}</td>
                        <td>
                          <Form.Select
                            size="sm"
                            value={item.categoriaId}
                            onChange={(e) => {
                              const newItens = [...itensTemp];
                              newItens[idx].categoriaId = parseInt(
                                e.target.value
                              );
                              setItensTemp(newItens);
                            }}
                            disabled={item.existente}
                          >
                            {categorias.map((cat) => (
                              <option key={cat.id} value={cat.id}>
                                {cat.nome}
                              </option>
                            ))}
                          </Form.Select>
                        </td>
                        <td className="text-center">
                          {item.existente ? (
                            <Badge bg="success">Existente</Badge>
                          ) : (
                            <Badge bg="info">Novo</Badge>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => setShowModal(false)}
            disabled={loadingConfirm || loadingSearch}
          >
            Cancelar
          </Button>
          <ButtonSpinner
            variant="primary"
            onClick={handleConfirmXml}
            loading={loadingConfirm}
            disabled={loadingSearch}
          >
            Confirmar Importação
          </ButtonSpinner>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default NFeCadastroReferenciaView;



